import React, { useEffect, useRef } from 'react';
import { Container, Heading } from '@charlietango/ui';
import { rem } from '../../styles/rem';

import Placeholder from '../../components/Placeholder/Placeholder';
import useScript from '../../hooks/useScript';
import { colors } from '../../styles/colors';
import { TextVariant } from '../../styles/typography';

export type CookieDeclarationProps = {
  title?: string;
};

const cdUrl =
  'https://consent.cookiebot.com/c2c1002a-5fb4-4563-9749-9e8a99f3568b/cd.js';

function CookieBotDeclaration() {
  const [ready] = useScript(cdUrl);
  const initialReady = useRef(ready);

  useEffect(() => {
    // If the script is already loaded, manually call init()
    if (initialReady.current && window.CookieDeclaration) {
      window.CookieDeclaration.init();
    }
  }, []);

  return (
    <>
      {!ready && <Placeholder />}
      <div
        sx={{
          maxWidth: rem(800),
          overflowX: 'auto',
          variant: 'text.' + TextVariant.BodyLg,
          color: colors.base.Text.Primary,
          a: { color: 'currentColor' },
        }}
      >
        {/* The script #CookieDeclaration is used by Cookiebot to inject the HTML for the declaration */}
        <script
          id="CookieDeclaration"
          src={cdUrl + '.placeholder'}
          type="text/plain"
        />
      </div>
    </>
  );
}

/**
 * Showcase the Cookie Declaration from Cookiebot
 * */
function CookieDeclaration({ title = 'Cookies' }: CookieDeclarationProps) {
  return (
    <Container
      as="article"
      sx={{
        maxWidth: 'unset',
        mx: 0,
        px: [rem(20), rem(20), 0],
        py: [rem(80), rem(96), rem(120)],
      }}
    >
      <div sx={{ maxWidth: rem(952), mx: 'auto' }}>
        <Heading
          as="h1"
          variant={TextVariant.Header3xl}
          sx={{
            mb: [rem(16), rem(16), rem(20)],
            color: colors.base.Text.Primary,
          }}
        >
          {title}
        </Heading>
        <CookieBotDeclaration />
      </div>
    </Container>
  );
}

CookieDeclaration.displayName = 'CookieDeclaration';

export default CookieDeclaration;
